import { connect } from 'react-redux';
import { IVillageForListPresenterSchema } from '../../repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { TTypedThunkDispatch } from '../../types/store';
import { trackingPhoneEvent } from '../../store/tracking/tracking';
import { MobileListItem, IMobileListItemProps } from '../../components/mobile/list_item';

type TMobileListItemContainerDispatchProps = Pick<IMobileListItemProps, 'trackPhoneOpened'>;

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TMobileListItemContainerDispatchProps {
  return {
    trackPhoneOpened(village: IVillageForListPresenterSchema) {
      dispatch(trackingPhoneEvent(village));
    },
  };
}

export const MobileListItemContainer = connect<null, TMobileListItemContainerDispatchProps>(
  null,
  mapDispatchToProps,
)(MobileListItem);
